import { useMemo } from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, Bar, BarChart, ResponsiveContainer } from 'recharts';
import { useGetMeteoRainDay } from '../../hooks/useGetMeteoRainDay';
import BarraLluvia from './BarraLluvia';

const GraficaMeteoLluviaDiaria = ( { meteoId , start , end } ) => {

    const dayStart = new Date(start);
    dayStart.setHours(0, 0, 0, 0);
    const dayEnd = new Date(end);
    dayEnd.setHours(23, 59, 59, 999);
    const { observations, loading } = useGetMeteoRainDay({
        meteoId,
        start: dayStart.toISOString(),
        end: dayEnd.toISOString()
    });

    const groupMaxRainPerDay = (data) => {
      if (data.length === 0) return [];

      const sorted = [...data].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      const dayRain = {};

      const getKey = (ts) => {
        const d = new Date(ts);
        return {
          key: d.getFullYear() + '-' +
            String(d.getMonth() + 1).padStart(2, '0') + '-' +
            String(d.getDate()).padStart(2, '0'),
          dateTs: new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0).getTime()
        };
      };

      sorted.forEach(({ timestamp }) => {
        const { key, dateTs } = getKey(timestamp);
        if (!dayRain[key]) dayRain[key] = { dayRain: 0, dateTs };
      });

      for (let i = 1; i < sorted.length; i++) {
        const increment = sorted[i].rainDay - sorted[i - 1].rainDay;
        if (increment > 0) {
          const { key } = getKey(sorted[i].timestamp);
          dayRain[key].dayRain += increment;
        }
      }

      return Object.values(dayRain);
    };

    const formattedObservations = useMemo(() =>
      groupMaxRainPerDay(observations).map(({ dateTs, dayRain }) => ({ date: dateTs, dayRain })),
    [observations]);


  return (
     <div>
           <h3>🌧️ Lluvia diaria</h3>
     
           {/* Gráfica */}
           {loading ? (
             <p>Cargando observaciones...</p>
           ) : formattedObservations?.length > 0 ? (
             <div style={{ backgroundColor: '#ffffff', borderRadius: '28px', padding: '10px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', marginTop: '10px' }}>
             <ResponsiveContainer width="100%" height={350}>
             <BarChart
               data={formattedObservations}
               margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
               barCategoryGap="10%"
             >
               <CartesianGrid strokeDasharray="3 3" />
               <XAxis
                  dataKey="date"
                  type="category"
                  domain={['auto', 'auto']}
                  tickFormatter={(time) => {
                    const date = new Date(time);
                    return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' });
                  }}
                  angle={-45}
                  textAnchor="end"
                  height={60}
                />

               <YAxis label={{ value: 'litros', angle: -90, position: 'insideLeft' }} />
               <Tooltip
                  cursor={false}
                  offset={100}
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      const date = new Date(label).toLocaleDateString('es-ES', {
                        weekday: 'long',
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit'
                      });

                      return (
                        <div style={{
                          backgroundColor: '#ffffff',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          padding: '10px',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                          color: '#333',
                          fontSize: 14
                        }}>
                          <p><strong>{date}</strong></p>
                          <p>🌧️ {payload[0].value} litros
                          </p>
                        </div>
                      );
                    }
                    return null;
                  }}
                />

               <Legend verticalAlign="top" height={36} align="right" />
               <Bar dataKey="dayRain" name="Lluvia" fill="#0080ffff" shape={<BarraLluvia />} />
             </BarChart>
             </ResponsiveContainer>
             </div>
           ) : (
             formattedObservations?.length === 0 && <p>No hay datos disponibles para esta estación meteo</p>
           )}
     
           
         </div>
  );
};

export default GraficaMeteoLluviaDiaria;
